import actions from "./actions";
import update from "./time/update";

export default {
  actions,
  modules: { update },
};
